import { isSuccess, post } from '@/axios'
import { TLogin } from '@/axios/axios-instance'
import { getCookieAuthInfo, setCookieAuthInfo } from '@/utils'

export const refreshToken = async () => {
  try {
    if (location.pathname.includes('/writing')) {
      return
    }

    const { refreshToken } = getCookieAuthInfo('refreshToken')
    const response = await post<TLogin>(
      '/user/refreshToken',
      {},
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      },
    )

    if (isSuccess(response)) {
      const { token, refresh_token, expire: tokenExpire } = response.data

      // 设置 token 到 cookie
      setCookieAuthInfo('token', token, {
        expires: new Date(Number(tokenExpire) * 1000),
      })
      setCookieAuthInfo('tokenExpire', tokenExpire, {
        expires: new Date(Number(tokenExpire) * 1000),
      })
      setCookieAuthInfo('refreshToken', refresh_token, {
        expires: new Date(Number(tokenExpire) * 1000),
      })
    } else {
      console.error(response.message)
    }

    return response
  } catch (error) {
    console.error('刷新 token 请求发生错误:', error)
  }
}

export const checkTokenExpiration = () => {
  const { token, tokenExpire } = getCookieAuthInfo('token', 'tokenExpire')

  if (token && tokenExpire) {
    const tokenExpireDate = new Date(Number(tokenExpire) * 1000)
    const currentDate = new Date()

    // 计算距离过期还有多少毫秒
    const timeUntilExpiration = tokenExpireDate.getTime() - currentDate.getTime()

    // 判断是否距离过期不足10分钟
    if (60 * 1000 < timeUntilExpiration && timeUntilExpiration < 10 * 60 * 1000) {
      // 调用 refreshToken 函数刷新 token
      refreshToken()
    }
  }
}
